import * as tslib_1 from "tslib";
import * as React from 'react';
import { withAnalyticsEvents, withAnalyticsContext, createAndFireEvent } from '@atlaskit/analytics-next';
import { name as packageName, version as packageVersion } from './version.json';
import Div from './styled';

var Blanket =
/** @class */
function (_super) {
  tslib_1.__extends(Blanket, _super);

  function Blanket() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Blanket.prototype.render = function () {
    var _a = this.props,
        canClickThrough = _a.canClickThrough,
        isTinted = _a.isTinted,
        onBlanketClicked = _a.onBlanketClicked;
    var onClick = canClickThrough ? null : onBlanketClicked;
    var containerProps = {
      canClickThrough: canClickThrough,
      isTinted: isTinted,
      onClick: onClick
    };
    return React.createElement(Div, tslib_1.__assign({}, containerProps));
  };

  Blanket.defaultProps = {
    canClickThrough: false,
    isTinted: false,
    onBlanketClicked: function onBlanketClicked() {}
  };
  return Blanket;
}(React.Component);

export { Blanket as BlanketWithoutAnalytics };
var createAndFireEventOnAtlaskit = createAndFireEvent('atlaskit');
export default withAnalyticsContext({
  componentName: 'blanket',
  packageName: packageName,
  packageVersion: packageVersion
})(withAnalyticsEvents({
  onBlanketClicked: createAndFireEventOnAtlaskit({
    action: 'clicked',
    actionSubject: 'blanket',
    attributes: {
      componentName: 'blanket',
      packageName: packageName,
      packageVersion: packageVersion
    }
  })
})(Blanket));